import React from 'react';

import './CoursePageHeader.scss';
import { isExternalLink } from '../../helpers/link';
import icons from '../../shared/assets/icons/redesign';

const { CoursesChevronLeft, CoursesChevronRight } = icons;

export default function CoursePageHeader({
  rightLink, title, link, NextLink, showEmailPopup
}) {
  const list = [{
    title: 'Zwangerschap',
    subtitle: 'Eva van hoorn',
    link: '/cursus/zwangerschapscursus/040verloskunde',
    imageUrl: '/courses/040verloskunde.png'
  }, {
    title: 'Borstvoeding',
    subtitle: '040 verloskundigen',
    imageUrl: '/courses/eva-van-hoorn.png',
    link: '/cursus/bevalcursus/eva-van-hoorn'
  }, {
    title: 'Zwangerschap',
    subtitle: 'Eva van hoorn',
    imageUrl: '/courses/nvl.png',
    link: '/cursus/borstvoedingscursus/nvl'
  }, {
    title: 'Sporten en bewegen',
    subtitle: 'Annelieke Janssen',
    imageUrl: '/courses/annelieke-janssen',
    link: '/cursus/sporten-en-bewegen/annelieke-janssen'
  }];

  return (
    <div className="coursePageHeader">
      <NextLink href={link}>
        <CoursesChevronLeft className="coursePageHeader-icon"/>
      </NextLink>

      <div className="coursePageHeader-title-wrap">
        <h1 className="coursePageHeader-title">
          {title}
        </h1>

        <div
          onClick={() => showEmailPopup(true)}
          className="coursePageHeader-right-link">
          Alles
          <CoursesChevronRight className="coursePageHeader-right-link-icon" />
        </div>
      </div>
    </div>
  );
}
